declare global {
  interface Window {
    Sentry: any;
  }
}

export type Activities = {
  updated_at: string;
  actor_count: number;
  verb: string;
  activity_count: number;
  time: string;
  activities: Activity[];
};

export type Activity = {
  tweet: string;
  verb: string;
  time: string;
  youtube_id: string;
  object: any;
  actor: {
    data?: {
      profileImage?: string;
      handle?: string;
      name?: string;
    };
  };
};

export type User = {
  id: string;
  avatar?: string;
  name?: string;
  handle?: string;
  allowPost?: boolean;
  client?: any;
  userToken?: string;
  serverSideToken?: string;
  following?: number;
  followers?: number;
  feedId?: string;
};

export type State = {
  stream: any;
  client: any;
  [UserIds.Eric]?: User;
  [UserIds.Jessica]?: User;
  [UserIds.Jule]?: User;
  serverSideToken?: string;
  feedback?: {
    type: 'success' | 'error';
    msg: string;
  };
};

export enum UserIds {
  Eric = 'eric',
  Jule = 'jule',
  Jessica = 'jessica',
}

export enum Actions {
  InitializeClient = 'initializeClient',
  AllowToPost = 'allowToPost',
  DisAllowToPost = 'disallowToPost',
  ClearFeedback = 'clearFeedback',
  SetError = 'setError',
}

export type Action =
  | {
      type: Actions.InitializeClient;
      client?: any;
      serverSideToken?: string;
      [UserIds.Jule]?: User;
      [UserIds.Eric]?: User;
      [UserIds.Jessica]?: User;
    }
  | { type: Actions.AllowToPost; allow: boolean }
  | { type: Actions.DisAllowToPost; allow: boolean }
  | { type: Actions.ClearFeedback }
  | { type: Actions.SetError; error: any };
